import React from 'react';
import { Link } from 'react-router-dom';
import withAxiosErrorBoundary from 'pages/admin/tools/edit/utils/withAxiosErrorBoundary';
import { EpdLinks } from 'routes/EpdRoutes';
import { useToolForOwner } from 'services/api/companyOwnedToolsQueries';
import styled from 'styled-components';
import CompanyOwnedToolHead from './CompanyOwnedToolHead';
import CompanyOwnedToolVersion from './CompanyOwnedToolVersion';
import { Skeleton } from 'primereact/skeleton';
import ToolFieldsGrid from './ToolFieldsGrid';
import OldUIReadonlyTextInputSkeleton from 'components/tools/OldUIReadonlyTextInputSkeleton';

interface Props {
  companyId: string;
  toolId: string;
}

const CompanyOwnedTool: React.FC<Props> = ({ companyId, toolId }) => {
  const tool = useToolForOwner(toolId).data;

  if (!tool) {
    return (
      <Wrapper>
        <HeaderWithBackButton to={EpdLinks.manageCompany(companyId, 'tools')}>
          <i className="pi pi-arrow-left" aria-label="Back" />
          <Skeleton width="300px" height="24px" />
        </HeaderWithBackButton>
        <SectionsList>
          <ToolFieldsGrid>
            <OldUIReadonlyTextInputSkeleton className="w-full" />
            {Array(8)
              .fill(0)
              .map((_, i) => (
                <OldUIReadonlyTextInputSkeleton key={i} />
              ))}
          </ToolFieldsGrid>
        </SectionsList>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <HeaderWithBackButton to={EpdLinks.manageCompany(companyId, 'tools')}>
        <i className="pi pi-arrow-left" aria-label="Back" />
        {tool.name}
      </HeaderWithBackButton>
      <SectionsList>
        <CompanyOwnedToolHead toolData={tool} />
        {tool.versions.map((v) => (
          <React.Fragment key={v.ord}>
            <Separator />
            <CompanyOwnedToolVersion toolData={tool} versionData={v} />
          </React.Fragment>
        ))}
      </SectionsList>
    </Wrapper>
  );
};

export default withAxiosErrorBoundary(CompanyOwnedTool);

const Wrapper = styled.div`
  max-width: 874px;
`;

const HeaderWithBackButton = styled(Link)`
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  gap: 8px;
  align-items: center;
  font-family: ${(props) => props.theme.fontFamilies.heading};
  color: #000000;
  text-decoration: none;
  font-size: 24px;
  font-weight: 500;
`;

const SectionsList = styled.div`
  display: grid;
  gap: 40px;
`;

const Separator = styled.div`
  width: 100%;
  height: 0;
  border-top: 1px solid ${(props) => props.theme.colors.elementsInputBorder};
`;
